// extracted by mini-css-extract-plugin
export default {"login_form":"Login_login_form__i0n+B"};